import { render, staticRenderFns } from "./OrderItemList.vue?vue&type=template&id=12fde1af&scoped=true&"
import script from "./OrderItemList.vue?vue&type=script&lang=js&"
export * from "./OrderItemList.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemList.vue?vue&type=style&index=0&id=12fde1af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fde1af",
  null
  
)

export default component.exports